import React, { useEffect, useMemo } from 'react';
import styled from 'styled-components';
import { buildAgentMarkdown } from '../../utils/agent/agentMarkdown';

const AgentDocument = styled.pre`
  margin: 0;
  min-height: 100vh;
  box-sizing: border-box;
  padding: 24px;
  white-space: pre-wrap;
  word-break: break-word;
  background: ${({ theme }) => theme.palette.background.paper};
  color: ${({ theme }) => theme.palette.text.primary};
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 14px;
  line-height: 1.5;
`;

function AgentMarkdownPage({ pathname }) {
  const markdown = useMemo(
    () => buildAgentMarkdown(pathname, { origin: window.location.origin }),
    [pathname],
  );

  useEffect(() => {
    const previousTitle = document.title;
    const titleMatch = markdown.match(/^title: "([^"]*)"/m);
    document.title = titleMatch ? titleMatch[1] : 'Millet';
    return () => {
      document.title = previousTitle;
    };
  }, [markdown]);

  return <AgentDocument>{markdown}</AgentDocument>;
}

export default AgentMarkdownPage;
